/**
 * searchView
 * @Object {Object} axboot.searchView
 */
axboot.searchView = {
    getData: function () {
        return axboot.util.getFormToParam(this.target);
    },
    setData: function setData(_obj) {
        for (var k in _obj) {
            if (k in this) {
                this[k].val(_obj[k]);
            }
        }
    },
    getCheckedValue: function getCheckedValue($inp) {
        if ($inp[0].type == "radio") {
            return $inp.filter(":checked").val();
        } else if ($inp[0].type == "checkbox") {
            return function (_$inp) {
                var vals = [];
                _$inp.filter(":checked").each(function () {
                    vals.push(this.value);
                });
                return vals.join(',');
            }.call(this, $inp);
        }
    }
};